module.exports = __webpack_public_path__ + "img/studyimg5.236c281f.jpg";